import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "ma-2" }

import { ref } from "vue";
import { apiQuery } from "@/api/j24api";

interface InspectorApiResponse {
  userData: {
    username: string;
    userStatus: string;
    enabled: boolean;
    email: string;
    email_verified: boolean;
    sub: string;
    attributes: {
      sub: string;
      identities: string;
      email_verified: string;
      "custom:Groups": string;
      name: string;
      "custom:groupsValidated": string;
      given_name: string;
      family_name: string;
      email: string;
    };
    groups: string[];
    groupNames: string[];
  };
  permissions: Array<{
    app: string;
    permissionName: string;
    actions: string[];
    scope: string;
  }>;
}

type Permission = InspectorApiResponse["permissions"][number];


export default /*@__PURE__*/_defineComponent({
  __name: 'adminInspector',
  setup(__props) {

const inspectorResponse = ref<InspectorApiResponse | null>(null);
const searchType = ref<"username" | "email" | "groups">("username");
const username = ref("jigsaw24-user@jigsaw24.com");
const emailAddress = ref("user@jigsaw24.com");
const groupIDs = ref("");
const loading = ref(false);
const elaGroups = ref<Array<{ groupID: string; name: string }>>([]);

async function getData() {
  loading.value = true;
  inspectorResponse.value = null; // Clear previous data
  try {
    let payload: any = {
      apiAction: "getResultantPermission",
    };

    if (searchType.value === "username") {
      payload.username = username.value;
    } else if (searchType.value === "email") {
      payload.emailAddress = emailAddress.value;
    } else {
      // Convert comma-separated string to array and trim whitespace
      const groupArray = groupIDs.value
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id.length > 0);
      payload.groupIDs = groupArray;
    }

    const result = await apiQuery("J24Auth", "elaadmin/users", payload);

    inspectorResponse.value = result as InspectorApiResponse;
    console.log(inspectorResponse.value);
    // Get Groups then match groupIDs to names
    const groupsResult = await apiQuery("J24Auth", "groups", {
      apiAction: "get",
    });
    console.log("Groups Result:", groupsResult);
    inspectorResponse.value.userData.groupNames = [];
    if (groupsResult.length) {
      console.log("ELA Groups:", groupsResult);
      elaGroups.value = groupsResult;
      // Match groupIDs to names
      inspectorResponse.value.userData.groups.forEach((groupID, index) => {
        const group = elaGroups.value.find((g) => g.groupID === groupID);
        if (group) {
          inspectorResponse.value!.userData.groupNames[index] = group.name;
        } else {
          inspectorResponse.value!.userData.groupNames[index] = "Unknown Group";
        }
      });
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    inspectorResponse.value = null; // Clear on error
  }
  loading.value = false;
}

function isGlobalScope(scope: string): boolean {
  return scope === "*";
}

function getRowClass(item: Permission): string {
  return isGlobalScope(item.scope) ? "global-scope-row" : "";
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createElementVNode("h1", null, "Permissions Inspector", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "8"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_form, {
                        onSubmit: _withModifiers(getData, ["prevent"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_radio_group, {
                            modelValue: searchType.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchType).value = $event)),
                            inline: "",
                            label: "Search By:",
                            class: "mb-4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_radio, {
                                label: "Cognito Username",
                                value: "username"
                              }),
                              _createVNode(_component_v_radio, {
                                label: "Email Address",
                                value: "email"
                              }),
                              _createVNode(_component_v_radio, {
                                label: "Group IDs",
                                value: "groups"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          (searchType.value === 'username')
                            ? (_openBlock(), _createBlock(_component_v_text_field, {
                                key: 0,
                                modelValue: username.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((username).value = $event)),
                                label: "Username",
                                variant: "outlined",
                                density: "comfortable",
                                required: "",
                                hint: "Enter the username (e.g., jigsaw24-login_user@jigsaw24.com)",
                                "persistent-hint": ""
                              }, null, 8, ["modelValue"]))
                            : (searchType.value === 'email')
                              ? (_openBlock(), _createBlock(_component_v_text_field, {
                                  key: 1,
                                  modelValue: emailAddress.value,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((emailAddress).value = $event)),
                                  label: "Email Address",
                                  variant: "outlined",
                                  density: "comfortable",
                                  required: "",
                                  hint: "Enter the user's email address",
                                  "persistent-hint": ""
                                }, null, 8, ["modelValue"]))
                              : (_openBlock(), _createBlock(_component_v_textarea, {
                                  key: 2,
                                  modelValue: groupIDs.value,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((groupIDs).value = $event)),
                                  label: "Group IDs",
                                  variant: "outlined",
                                  density: "comfortable",
                                  required: "",
                                  rows: "3",
                                  hint: "Enter comma-separated group IDs (e.g., d29b0190-1625-47cf-bw89-445c1e3cefcb, 83cacf5f-48cc-4a21-b166-b30d93d2d79f)",
                                  "persistent-hint": ""
                                }, null, 8, ["modelValue"])),
                          _createVNode(_component_v_btn, {
                            type: "submit",
                            color: "primary",
                            variant: "elevated",
                            loading: loading.value,
                            class: "mt-4"
                          }, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createTextVNode(" Inspect User ")
                            ])),
                            _: 1
                          }, 8, ["loading"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (loading.value)
        ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_progress_linear, {
                    indeterminate: "",
                    color: "primary"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (inspectorResponse.value && !loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (inspectorResponse.value.userData.username !== 'anonymous')
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 0,
                  class: "mt-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, null, {
                              default: _withCtx(() => _cache[6] || (_cache[6] = [
                                _createTextVNode("User Data")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_card_text, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_table, { density: "comfortable" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("tbody", null, [
                                      _createElementVNode("tr", null, [
                                        _cache[7] || (_cache[7] = _createElementVNode("td", {
                                          class: "font-weight-bold",
                                          style: {"width":"200px"}
                                        }, " Username ", -1)),
                                        _createElementVNode("td", null, _toDisplayString(inspectorResponse.value.userData.username), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _cache[8] || (_cache[8] = _createElementVNode("td", { class: "font-weight-bold" }, "Status", -1)),
                                        _createElementVNode("td", null, _toDisplayString(inspectorResponse.value.userData.userStatus), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _cache[9] || (_cache[9] = _createElementVNode("td", { class: "font-weight-bold" }, "Email", -1)),
                                        _createElementVNode("td", null, _toDisplayString(inspectorResponse.value.userData.email), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _cache[10] || (_cache[10] = _createElementVNode("td", { class: "font-weight-bold" }, "Email Verified", -1)),
                                        _createElementVNode("td", null, _toDisplayString(inspectorResponse.value.userData.email_verified ? "Yes" : "No"), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _cache[11] || (_cache[11] = _createElementVNode("td", { class: "font-weight-bold" }, "Enabled", -1)),
                                        _createElementVNode("td", null, [
                                          _createVNode(_component_v_chip, {
                                            color: 
                          inspectorResponse.value.userData.enabled
                            ? 'success'
                            : 'error'
                        ,
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(inspectorResponse.value.userData.enabled ? "Yes" : "No"), 1)
                                            ]),
                                            _: 1
                                          }, 8, ["color"])
                                        ])
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _cache[12] || (_cache[12] = _createElementVNode("td", { class: "font-weight-bold" }, "Given Name", -1)),
                                        _createElementVNode("td", null, _toDisplayString(inspectorResponse.value.userData.attributes.given_name), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _cache[13] || (_cache[13] = _createElementVNode("td", { class: "font-weight-bold" }, "Family Name", -1)),
                                        _createElementVNode("td", null, _toDisplayString(inspectorResponse.value.userData.attributes.family_name), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _cache[15] || (_cache[15] = _createElementVNode("td", { class: "font-weight-bold" }, [
                                          _createTextVNode(" Groups "),
                                          _createElementVNode("div", { class: "font-weight-medium" }, " (GroupID, Group Name) ")
                                        ], -1)),
                                        _createElementVNode("td", null, [
                                          _createVNode(_component_v_sheet, { class: "d-flex flex-wrap" }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inspectorResponse.value.userData
                            .groups, (group, idx) => {
                                                return (_openBlock(), _createBlock(_component_v_sheet, {
                                                  class: "ma-3",
                                                  rounded: "lg",
                                                  color: "grey-lighten-3",
                                                  key: idx
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_2, [
                                                      _createTextVNode(_toDisplayString(group), 1),
                                                      _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                                                      _createTextVNode(" " + _toDisplayString(inspectorResponse.value.userData.groupNames[idx]), 1)
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              }), 128))
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_sheet, {
                                            color: "grey-lighten-3",
                                            rounded: "lg"
                                          })
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_row, { class: "mt-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_title, null, {
                          default: _withCtx(() => [
                            _cache[16] || (_cache[16] = _createTextVNode(" Permissions ")),
                            _createVNode(_component_v_chip, {
                              size: "small",
                              class: "ml-2"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(inspectorResponse.value.permissions.length) + " total ", 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card_subtitle, { class: "mt-2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              size: "small",
                              color: "warning"
                            }, {
                              default: _withCtx(() => _cache[17] || (_cache[17] = [
                                _createTextVNode("mdi-alert")
                              ])),
                              _: 1
                            }),
                            _cache[18] || (_cache[18] = _createTextVNode(" Rows highlighted in orange have global scope (*) "))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_data_table, {
                              headers: [
                  { title: 'App', key: 'app', sortable: true },
                  {
                    title: 'Permission Name',
                    key: 'permissionName',
                    sortable: true,
                  },
                  { title: 'Actions', key: 'actions', sortable: false },
                  { title: 'Scope', key: 'scope', sortable: true },
                ],
                              items: inspectorResponse.value.permissions,
                              density: "comfortable",
                              "item-class": getRowClass
                            }, {
                              [`item.actions`]: _withCtx(({ item }) => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.actions, (action, idx) => {
                                  return (_openBlock(), _createBlock(_component_v_chip, {
                                    key: idx,
                                    size: "x-small",
                                    class: "ma-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(action), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              [`item.scope`]: _withCtx(({ item }) => [
                                _createVNode(_component_v_chip, {
                                  color: isGlobalScope(item.scope) ? 'warning' : 'default',
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.scope), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["color"])
                              ]),
                              _: 2
                            }, 1032, ["items"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})